import { serialize } from './serialize';

export const getSeoText = (seo, popdir) => {
    const seoText = seo?.seo_text;
    const popdirText = popdir?.seo_text_b2b;

    return seoText || popdirText
};

export const seoData = (_seo, popdir) => getSeoText(_seo, popdir).map((item, index) => ({
  title: _seo.seo_text_caption[index],
  description: serialize(item.flat(Infinity)),
}))

export const hasSeoCaption = _seo => !!_seo?.seo_text_caption?.filter(Boolean).length;
export const hasSeoText = (_seo, popdir) => !!getSeoText(_seo, popdir);

export const hasSeo = (_seo, popdir) => hasSeoCaption(_seo) && hasSeoText(_seo, popdir);